import { load, dump } from 'js-yaml';

export type ParsedTask = {
  name: string;
  state: string;
  fields: string[];
  instrumentName: string;
  taskYaml: string;
  taskValues: string;
  taskKey: string;
  hasAlias: boolean;
};

export function parseYamlTasks(yaml: string): ParsedTask[] {
  try {
    let splitTasks = load(yaml.trim());

    if (!Array.isArray(splitTasks)) {
      splitTasks = [splitTasks];
    }

    return (splitTasks as any[]).map((task) => {
      const taskKey = typeof task === 'object' ? Object.keys(task)[0] : task;
      const taskValues = typeof task === 'object' ? task[taskKey] || {} : {};

      const instrumentName = taskKey.split('.')[0];
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { alias, register, identifier, ...rest } = taskValues;
      const fields = Object.entries(taskValues).map(([key, value]) => `${key}: ${value}`);

      return {
        name: alias || taskKey,
        instrumentName,
        taskKey,
        hasAlias: Boolean(alias),
        state: '',
        taskYaml: dump(task),
        fields,
        taskValues: Object.keys(rest).length > 0 ? dump(rest) : '',
      };
    });
  } catch {
    return [];
  }
}

